module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/core-js/object/entries.js
 ** module id = 448
 ** module chunks = 0
 **/